
// TEXTAREA
//
// INFO: Let TEXTAREAs always get the correct height to match it’s content


document.addEventListener("DOMContentLoaded", function () {
    const className = document.querySelector('.input') ? 'input' : 'hs-input';

    // Function to get computed style property value
    function getComputedStyleProperty(element, property) {
        return parseFloat(window.getComputedStyle(element, null).getPropertyValue(property));
    }

    // Function to resize textarea
    function resizeTextarea(textarea) {
        const textareaBorderBlockStartWidth = getComputedStyleProperty(textarea, "border-block-start-width");
        const textareaBorderBlockEndWidth = getComputedStyleProperty(textarea, "border-block-end-width");
        const textareaPaddingBlockStart = getComputedStyleProperty(textarea, "padding-block-start");
        const textareaPaddingBlockEnd = getComputedStyleProperty(textarea, "padding-block-end");
        const textareaLineHeight = getComputedStyleProperty(textarea, "line-height");

        const textareaChromeHeight = textareaBorderBlockStartWidth + textareaBorderBlockEndWidth + textareaPaddingBlockStart + textareaPaddingBlockEnd;

        textarea.style.height = "auto";

        // Calculate textareaContentHeight ensuring it's at least one line-height
        const textareaContentHeight = Math.max(textarea.scrollHeight - textareaChromeHeight, textareaLineHeight);
        const textareaLines = Math.ceil(textareaContentHeight / textareaLineHeight);
        const textareaElementHeight = textareaChromeHeight + (textareaLines * textareaLineHeight);

        textarea.style.height = textareaElementHeight + "px";
    }

    // Function to initialize resizing for all textareas with the specified classes
    function initializeTextareas() {
        const textareas = document.querySelectorAll(`textarea.${className}`);
        textareas.forEach(textarea => {
            // Set rows attribute to 1 to avoid default browser rows value
            textarea.setAttribute("rows", 1);

            // Initial resize
            resizeTextarea(textarea);

            // Resize on input event
            textarea.addEventListener("input", function () {
                resizeTextarea(textarea);
            });
        });
    }

    // Observe DOM changes to detect dynamically added textareas
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Check if the added node is an element
                        if (node.matches(`.${className.replace(/\s+/g, '.')}`)) {
                            // Apply resize function if the added node is a textarea with the classes
                            initializeTextareas();
                        } else {
                            // Check if the added node contains textareas with the classes
                            const nestedTextareas = node.querySelectorAll(`.${className.replace(/\s+/g, '.')}`);
                            if (nestedTextareas.length > 0) {
                                initializeTextareas();
                            }
                        }
                    }
                });
            }
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Initial initialization
    initializeTextareas();
});
